import { createAuthenticatedAxiosInstance } from "./axiosInstance";

export const SYNONYMS_API_URL =
  process.env.REACT_APP_SYNONYMS_API_URL || "https://dev-greenback-app-tenants-tin.azurewebsites.net";

const axiosInstanceSynonyms = createAuthenticatedAxiosInstance(SYNONYMS_API_URL);

export default axiosInstanceSynonyms;
